import { Component, EventEmitter, Inject, OnInit, Output, PLATFORM_ID, ViewChild } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { ConfirmDetailsComponent } from './confirm-details/confirm-details.component';
import { MatButtonModule } from '@angular/material/button';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { ILead } from 'app/core/shared-services/shared-interface.types';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { SummaryComponent } from './summary/summary.component';
import { IPackages, iTerms } from 'app/core/shared-services/interfaces.types';
import { PaymentComponent } from './payment/payment.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { TermsComponent } from './terms/terms.component';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { sha256 } from 'js-sha256';
import { AuthService } from 'app/core/auth/auth.service';
import Swal from 'sweetalert2';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-confirm-order',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, MatButtonModule, RouterLink, FuseAlertComponent, MatStepperModule, PaymentComponent, ConfirmDetailsComponent, OrderDetailsComponent, SummaryComponent, TermsComponent],
  templateUrl: './confirm-order.component.html',
  styleUrls: ['./confirm-order.component.scss']
})
export class ConfirmOrderComponent implements OnInit {

  @ViewChild('stepper') stepper: MatStepper;

  public leadResult: any;
  public lead: ILead;
  public center: { lat: number, lng: number };

  private orderResult: any;
  public order: Array<IPackages>;
  public addOns: Array<IPackages>;

  private upFrontAmountResult: any;
  public upFrontAmount: number = 0;
  public monthlyAmount: number = 0;
  public beforeTax: number = 0;
  public VAT: number = 0;
  public totalAmount: number = 0;

  public leadActionType: any;

  public confirmDetailsValid: boolean = false;
  public debitOrderWasSigned: boolean = false;
  public confirmDetailsForm: any;
  public confirmOrderValid: boolean = false;
  public confirmOrderForm: any;

  public hasPaymentMethod: boolean = false;

  public alert: { type: FuseAlertType; message: string };
  public showAlert: boolean = false;

  public acceptedTerms: any;
  public detailsConfirmed: boolean = false;
  public isDesktop: boolean = false;
  public allTermsAccepted: boolean;

  public placeOrderLoader: boolean = false;

  private referrer: string;

  public isLeadUpdated: boolean;
  public isGtmTaggingSuccess: boolean;
  public placeOrderLead: any;


  /**
   * Constructor
 */

  constructor(
    private _sharedMethods: SharedMethodsModule,
    private _webStorage: WebStorage,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private _gtmService: GtmService,
    private _authService: AuthService,

    @Inject(PLATFORM_ID) private platformId: any

  ) {
    this.breakpointObserver.observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
      .subscribe(result => {
        this.isDesktop = result.matches;
      });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */

  async ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {

      if(localStorage.getItem('currentURL')) {
        if(localStorage.getItem('currentURL') == window.location.href) {
          //this.referrer = window.location.href
        } else {
          this.referrer = localStorage.getItem('currentURL')
          localStorage.setItem('currentURL', window.location.href);
          localStorage.setItem('previousURL', this.referrer);
        }
      } else {
        localStorage.setItem('currentURL', window.location.href);
      }

        const route = window.location.href;
        const path = this.router.url;

        this._gtmService.confirmOrderReferrer = this.referrer;

        this._gtmService.pushEvent({ 
          event: 'page_view',
          page_url: route,
          page_path: path,
          page_title: 'confirm_order_page',
          page_referrer: route
        });
      }


    // Get Lead
    this.leadResult = await this._sharedMethods.getLeadById(this._webStorage.CartInfo.getValue()?.LeadEntityID);

    if (this.leadResult.success) {
      this.lead = this.leadResult.result;
      if (this.lead.LeadActionTypeCode == 'ServiceUpgrade' || this.lead.LeadActionTypeCode == 'ServiceDowngrade') {
        //this.stepper.selectedIndex = this.stepper.selectedIndex + 2;

        for (let idx = 0; idx < 2; idx++) {
          this.stepper.next();
        }

      }
      this.center = { lat: this.lead?.Latitude, lng: this.lead?.Longitude };
    }

    // Get Linked offerables on lead
    this.orderResult = await this._sharedMethods.getLinkedOfferablesByLeadId(this._webStorage.CartInfo.getValue().LeadEntityID);
    if (this.orderResult.success) {
      this.order = this.orderResult.result.filter(item => !item.IsAddOn);
      this.addOns = this.orderResult.result.filter(item => item.IsAddOn);
      this.order.forEach(item => {
        if (item.Billing_IsRecurring) {
          this.monthlyAmount += item.Billing_TotalIncl
        }
      });
    }

    // Get upfront Payment
    this.upFrontAmountResult = await this._sharedMethods.getUpfrontAmountDue(this._webStorage.CartInfo.getValue().LeadEntityID);
    if (this.upFrontAmountResult.success) {
      const upFrontAmountResult = this.upFrontAmountResult.result;
      this.VAT = (15 / 100) * upFrontAmountResult
      this.upFrontAmount = upFrontAmountResult;
    }

    // TODO: If Debit order has been accepted || declined 
    //  this.stepper.selectedIndex = this.stepper.selectedIndex + 3;

    // if payment status is found in param
    if (this.activatedRouter.snapshot.queryParamMap.get('status')) {
      if (this.activatedRouter.snapshot.queryParamMap.get('status') == 'successful') {
        this.stepper.selectedIndex = this.stepper.selectedIndex + 3;
        this.alert = {
          type: 'success',
          message: 'Your payment was successful!'
        }
        this.showAlert = true;
      } else {
        this.stepper.selectedIndex = this.stepper.selectedIndex + 3;
        this.alert = {
          type: 'error',
          message: 'Your payment was not successful!'
        }
        this.showAlert = true;
      }
    }

  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  public async placeOrder() {
    this.placeOrderLoader = true;
    // accept all terms and conditions
    // use for loop rather than foreach to ensure sync

    let allTermsSent: boolean;

    for (let i = 0; i < this.acceptedTerms.length; i++) {
      const termServiceResult: any = await this._sharedMethods.acceptTermsAndConditions(this.lead.LeadEntityID, this.acceptedTerms[i].TermsAndConditionsTemplateID);
      if (termServiceResult.success) {
        this.acceptedTerms[i].apiCallPassed = true;
      } else {
        this.acceptedTerms[i].apiCallPassed = false;
      }
    }

    this.acceptedTerms.forEach((element: iTerms) => {
      if (element.apiCallPassed) {
        allTermsSent = true;
      } else {
        this.alert = { type: 'error', message: 'Acceptance of terms and conditions failed' };
        this.showAlert = true;
      }
    });

    if (allTermsSent && this.allTermsAccepted) {

      this.isLeadUpdated = await this.updateLead();
      this.isGtmTaggingSuccess = await this.gtmTagging('order_complete');

      if (this.isGtmTaggingSuccess && this.isLeadUpdated) {
        this._webStorage.UpdateCart('remove');
        localStorage.removeItem('LeadEntityID');
        this.router.navigateByUrl('/dashboard#orders').then(() => {
          location.reload();
        });
      } else {
        this.placeOrderLoader = false;
        Swal.fire({
            title: 'Error!',
            html: 'Error placing order<br><br>Please contact support for assistance',
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OKAY',
            showConfirmButton: true,
            customClass: {
              htmlContainer: 'text-lg',
              confirmButton: 'custom-button text-md bg-accent text-black rounded-full',
            }
        });
      }
    }
  }

  public confirmDetails(val: any) {
    this.confirmDetailsValid = true;
    this.confirmDetailsForm = val;
  }

  public confirmDebitOrderSignedValue(val: boolean) {
    this.debitOrderWasSigned = val;
    console.log('Debit order signed value:', val);
  }

  public confirmOrder(val: any) {
    if (val !== null) {
      this.confirmOrderValid = true;
      this.confirmOrderForm = val;
    } else {
      this.confirmOrderValid = false;
    }
  }

  public async updateLead(gtmEventName?: string) {
    let leadUpdate: any

    const lead = await this._sharedMethods.getLeadById(localStorage.getItem('LeadEntityId'));
    if (lead.success) {
      this.placeOrderLead = lead.result;
  
      this.placeOrderLead.Audit_IsActive = true;
      if(this.placeOrderLead.LeadActionTypeCode == 'Interest' || this.placeOrderLead.LeadActionTypeCode == 'Feasibility' || this.placeOrderLead.LeadActionTypeCode == 'PreOrder') {
        this.placeOrderLead.LeadActionTypeCode = 'Order';
      }
      this.placeOrderLead.LeadDescription = this.placeOrderLead.LeadActionTypeCode;
      if (this.placeOrderLead) {
        leadUpdate = await this._sharedMethods.updateLead(Object.assign(this.placeOrderLead, this.confirmDetailsForm, this.confirmOrderForm));
        if(leadUpdate.success) {
          if(gtmEventName) {
            const gtmTagging = await this.gtmTagging(gtmEventName);
            if(gtmTagging) {
              return true;
            }
          } else {
            return true;
          }
        }
      } else {
        console.error('Error updating lead', this.placeOrderLead)
      }
    } else {
      console.error('Error fetching lead', lead.error);
      return false;
    }
  }

  public async gtmTagging(gtmEventName: string) {
    if (isPlatformBrowser(this.platformId)) {

      //this.leadActionType = await this._sharedMethods.setLeadActionType(this.lead?.LeadEntityID, 'Order');


      if (gtmEventName == "confirm_order") {
        const route = window.location.href;
        const path = this.router.url;
;

        this._gtmService.pushEvent({ 
          event: 'payment_page_view',
          page_url: route,
          page_path: path,
          page_title: 'confirm_order_page',
          page_referrer: route
        });
      }

      if(localStorage.getItem('currentURL')) {
        if(localStorage.getItem('currentURL') == window.location.href) {
          //this.referrer = window.location.href
        } else {
          this.referrer = localStorage.getItem('currentURL')
          localStorage.setItem('currentURL', window.location.href);
          localStorage.setItem('previousURL', this.referrer);
        }
      } else {
        localStorage.setItem('currentURL', window.location.href);
      }

      let orderCompleteData = {};
      
      const route = window.location.href;
      const path = this.router.url;

      if (gtmEventName == 'order_complete') {
        orderCompleteData = {
          order_number: this._webStorage.CartInfo.getValue().LeadEntityID,
          order_value: this.monthlyAmount !== 0 ? this.monthlyAmount : this.upFrontAmount
        }
      }

      let phoneNumber;

      if (this.confirmDetailsForm?.MobileNumber.startsWith('0')) {
        // Remove the '0' and add '+27'
        phoneNumber = '+27' + this.confirmDetailsForm.MobileNumber.slice(1);
      } else {
        phoneNumber = this.confirmDetailsForm.MobileNumber
      }

      let emailHash = '';
      if (this._authService._authenticated) {
        emailHash = localStorage.getItem('emailHash')
      } else {
        emailHash = sha256(this.confirmDetailsForm.EmailAddress);
      }



      try {
        this._gtmService.pushEvent({
          event: gtmEventName,
          page_url: route,
          page_path: path,
          page_title: 'confirm_order_page',
          page_referrer: route,
          email: emailHash,
          phone: sha256(phoneNumber),
          ...orderCompleteData
        });
      } catch (error) {
        console.error('Error pushing GTM event:', error);
      }
    }

    return true;

  }

  public hasPaymentMethodEvent(val: boolean) {
    this.hasPaymentMethod = val;
  }

  public confirmDetailsValue(val: boolean) {
    this.detailsConfirmed = val;
  }


  public termsCheckedValue(val: boolean) {
    this.acceptedTerms = val;
    if(this.acceptedTerms.length == 0) {
      this.allTermsAccepted = false;
    }
    this.allTermsAccepted = this.acceptedTerms.every(element => element.isAccepted);

  }



  scrollToTop() {
    if (window.innerWidth < 600) { // Adjust as needed for desktop screen size check
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  public goToCart() {
    this.router.navigateByUrl('/cart');
  }

}
